// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import type { Tracks, SliderItem } from 'react-compound-slider';
import styles from '../styles';
type Props = {
  source: SliderItem;
  target: SliderItem;
  disabled?: boolean;
  getTrackProps: Tracks['getTrackProps'];
  accentColor?: string;
};

const Track = ({ source, target, disabled, getTrackProps, accentColor }: Props) => {
  const style: Record<string, string> = {
    left: `${source.percent}%`,
    width: `${target.percent - source.percent}%`,
  };

  if (accentColor) {
    style['--tui-slider-accent-color'] = accentColor;
  }
  return (
    <div className={styles.touchArea} {...(disabled ? undefined : getTrackProps())}>
      <div style={style} className={styles.track} />
    </div>
  );
};

export default memo(Track);
